import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addCard: {
    defaultMessage: 'Add a Card',
  },
});
